import { ToolsTranslations } from '@/lib/translations/types';

export interface RoocValues { operatingIncome: number; operatingCapital: number }
export interface RoocResult { percent: number | null; isValid: boolean; message?: string }

// ROOC (%) = Operating income / Operating capital * 100
export function calculateRooc(values: RoocValues, t?: ToolsTranslations['rooc']): RoocResult {
  const { operatingIncome, operatingCapital } = values;
  if (operatingIncome < 0) return { percent: null, isValid: false, message: t?.invalid.operatingIncome };
  if (operatingCapital <= 0) return { percent: null, isValid: false, message: t?.invalid.operatingCapital };
  const percentRaw = (operatingIncome / operatingCapital) * 100;
  const percent = Math.round(percentRaw); // 0 decimals as in screenshot 257 %
  if (!isFinite(percent)) return { percent: null, isValid: false, message: t?.invalid.generic };
  return { percent, isValid: true };
}


